<template>
    <hh-msg-display v-if="error"
                    :message="error" type="error" />
    <hh-msg-display v-else-if="hasSlot"
                    type="error">
        <slot />
    </hh-msg-display>
</template>

<script>

export default {

    props: {
        error: {
            type: String,
            default: null,
        },
    },

    computed: {
        hasSlot() {
            return this.$slots.default
        },
    },

    mounted() {
        if (this.error)
            this.$logger.error(this.error)
    },

    updated() {
        if (this.error)
            this.$logger.error(this.error)
    },
}

</script>
